import {
	BaseRegisteredExtension,
	ExtensionContextType,
	ExtensionManifest,
	ExtensionPermissions,
	ExtentionPriority,
	IRegisteredExtension,
	IExecutionResult,
	InternalCallState,
	IDynamicValue,
	DEFAULT_MODULE_IDS
} from '@elyx-code/project-logic-tree';
import { EditorService } from '../../../EditorService';
import { browserCreatePersistedEntityImplementation } from '../../../../execution/built-in-function-implementations';
import { Execution } from '../../../../execution';

export class BuiltInFunctionImplementationCreatePersistedEntityModule
	extends BaseRegisteredExtension
	implements
		IRegisteredExtension<{
			main: (
				entity: InternalCallState,
				inputs: IDynamicValue[],
				execution?: Execution
			) => Promise<IExecutionResult>;
		}>
{
	manifest: ExtensionManifest = {
		id: DEFAULT_MODULE_IDS.BUILT_IN_FUNCTION_IMPLEMENTATIONS__CREATE_PERSISTED_ENTITY,
		version: '1.0.0',
		description:
			'Implementation for the built-in function "Create Persisted Entity". It saves the current entity state to the persisted storage.',
		initPriority: ExtentionPriority.High,
		permissions: [ExtensionPermissions.All],
		contexts: [ExtensionContextType.Editor, ExtensionContextType.Logic]
	};

	module = {
		main: (
			entity: InternalCallState,
			inputs: IDynamicValue[],
			execution?: Execution
		) => {
			const editorContext = this.extensionsRegistry.requestContexts(
				this,
				[ExtensionContextType.Editor]
			)[0] as EditorService;

			return browserCreatePersistedEntityImplementation(
				entity,
				inputs,
				editorContext,
				execution
			);
		}
	};
}
